import { DataFieldValueV2 } from "@iventis/domain-model/model/dataFieldValueV2";

/** Corrects the DataFieldValueV2 type from the domain model (valueDate as string, valueText and valueRepeatedTimeRanges changed to optional) */
export type DataFieldValueV2Extended = Omit<DataFieldValueV2, "valueDate" | "valueText" | "valueRepeatedTimeRanges"> & {
    /** valueDate comes from the API as a string */
    valueDate?: DataFieldValueV2["valueDate"] | string;
    valueText?: DataFieldValueV2["valueText"];
    valueRepeatedTimeRanges?: DataFieldValueV2["valueRepeatedTimeRanges"];
};
